import { render, staticRenderFns } from "./departureAndTransfer.vue?vue&type=template&id=11386372&scoped=true"
import script from "./departureAndTransfer.ts?vue&type=script&lang=ts&external"
export * from "./departureAndTransfer.ts?vue&type=script&lang=ts&external"
import style0 from "./departureAndTransfer.scss?vue&type=style&index=0&id=11386372&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11386372",
  null
  
)

export default component.exports